export const CLASSES = ['6', '7', '8'] as const;
export const CLASS_NAMES: Record<string, string> = {
  '6': 'Class VI',
  '7': 'Class VII',
  '8': 'Class VIII',
};

export function computeLevel(avg: number): string {
  if (avg >= 85) return 'Excellent';
  if (avg >= 70) return 'Good';
  if (avg >= 55) return 'Average';
  return 'Below Average';
}
